import { setAnalytics } from '../../../thd-analytics-utils';
import {
  ACCOUNT,
  ADD_MANAGE_USERS_PAGE,
  ADD_MANAGE_USERS_PAGE_TYPE,
  BULK_ADD_PAGE
} from '../../../constants';

export function manageUsersBulkAdd() {
  window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on('manage-users-bulk-add.page-load', () => {
    digitalData.page = {
      pageInfo: {
        pageName: BULK_ADD_PAGE,
        pageType: ADD_MANAGE_USERS_PAGE_TYPE
      },
      category: {
        primaryCategory: ACCOUNT,
        subCategory1: ADD_MANAGE_USERS_PAGE,
        subCategory2: BULK_ADD_PAGE
      }
    };

    setAnalytics(digitalData);
  });
}
